import React from "react";

import { z } from "zod/v4-mini";

export type Options = Record<string, React.ReactNode>;

const selectOptionSchema = z.object({
  props: z.object({
    value: z.string(),
    children: z.any(),
  }),
});

export const findOptionsFromChildren = (children: React.ReactNode) => {
  if (!children) {
    return {};
  }
  let childrenList: React.ReactNode[] = [children];
  childrenList = childrenList.flat(Infinity);
  const result: Options = {};
  for (const child of childrenList) {
    const parsedChild = selectOptionSchema.safeParse(child);
    if (parsedChild.success) {
      result[parsedChild.data.props.value] = parsedChild.data.props.children;
    }
  }
  return result;
};

export const selectOption = (node: React.ReactNode) => {
  const result = selectOptionSchema.safeParse(node);
  if (result.success) {
    return { newValue: result.data.props.value || undefined };
  }
  return undefined;
};
